import React from 'react';
import { withTranslation } from 'react-i18next';
import { post } from '../../api/requests';

import ErrorPage from './ErrorPage';
import { customAlphabet } from 'nanoid';
const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ', 7);
import ROUTES from '../../constants/routes';

import StackTrace from 'stacktrace-js';
import { StatusCodes } from 'http-status-codes';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      errorId: nanoid(),
      status: error?.status,
      errMsg: error?.errMsg,
      name: error?.name,
    };
  }

  async componentDidCatch(error, _errorInfo) {
    try {
      const { errorId, status, name } = this.state;
      let frames = [];

      if (error instanceof Error) {
        frames = await StackTrace.fromError(error)
      }

      const stack = frames.map((frame) => frame.toString()).join('\n');

      await post('/v1/error', {
        errorId,
        message: error?.message || 'unknown',
        stack,
        status,
        name,
      });

    } catch (_e) {
      // not much we can do here
    }
  }

  render() {

    const { hasError, errorId, status, name, errMsg } = this.state;
    let home = this.props.home;
    const { t } = this.props;

    if (hasError) {

      let buttonText = t('common.take-me-home');

      let message = (
        <>
          <p>{t('common.error-with-code')}</p>
          <p className="lead">{errorId}</p>
        </>
      );

      if (status === StatusCodes.UNAUTHORIZED) {
        message = <p>{t('common.error-session-expired')}</p>;
      }

      // HTTP 402 Payment Required
      // server will respond with this if a trainer doesn't have enough licenses
      // or if a Heroes customer is missing payments on their subscription
      if (status === StatusCodes.PAYMENT_REQUIRED) {

        if (errMsg == 'coach') {
          message =
            <p>{t('common.error-licences')}</p>;

          buttonText = t('common.manage-licences');
          home = ROUTES.COACH.LICENSES;

        } else if (errMsg == 'owner') {
          message =
            <p>{t('common.subscription-error')}</p>;

          buttonText = 'Renew subscription';
          home = ROUTES.OWNER.RENEW;
        }
      }

      if (name === 'ChunkLoadError') {
        message = <p>{t('common.error-reload')}</p>
        buttonText = t('common.reload');
      }

      return (
        <ErrorPage buttonText={buttonText} home={home}>
          { message }
        </ErrorPage>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
